import PageHero from "@/components/PageHero";
import EnquiryForm from "@/components/EnquiryForm";
import CTABanner from "@/components/CTABanner";

const VisitingCarePage = () => {
  return (
    <main data-testid="page-visiting-care">
      <PageHero
        eyebrow="Visiting Care"
        title="From a 30-minute call, to four times a day."
        subtitle="Flexible, dignified hourly visits — built around their routine, their interests, and their pace. The same warm, familiar carer, every visit."
      />

      <section className="section">
        <div className="container-px max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <span className="eyebrow">What a visit can include</span>
            <h2 className="font-display text-4xl md:text-5xl mt-4 text-[var(--ss-teal-800)]">
              The little things, done beautifully.
            </h2>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {[
                ["fa-mug-hot", "Companionship & a chat", "A proper cup of tea, the paper read together, a walk to the end of the road."],
                ["fa-shower", "Personal care", "Bathing, dressing, continence support — discreetly and respectfully."],
                ["fa-pills", "Medication prompts", "Right dose, right time. Taken together if it helps."],
                ["fa-utensils", "Meal preparation", "Meals cooked just how they like them. Lunch on the table, properly."],
                ["fa-broom", "Light housekeeping", "Tidy kitchen, clean linen, a calm home — without the fuss."],
                ["fa-car", "Trips & appointments", "GP visits, the post office, lunch with friends — accompanied with care."],
              ].map(([icon, title, body]) => (
                <div key={title} className="card-soft" data-testid={`visiting-task-${title}`}>
                  <div className="w-11 h-11 rounded-full bg-[var(--ss-cream)] text-[var(--ss-teal-700)] flex items-center justify-center">
                    <i className={`fa-solid ${icon}`}></i>
                  </div>
                  <h3 className="font-serif text-xl text-[var(--ss-teal-800)] mt-4">{title}</h3>
                  <p className="text-[var(--ss-ink-soft)] text-sm mt-2">{body}</p>
                </div>
              ))}
            </div>

            <div className="mt-12 rounded-3xl bg-[var(--ss-teal-800)] text-[var(--ss-cream)] p-8 md:p-10">
              <div className="font-serif text-2xl md:text-3xl">
                Our minimum visit is{" "}
                <em className="not-italic text-[var(--ss-gold)]">one hour</em>.
              </div>
              <p className="mt-3 text-[var(--ss-cream)]/85 max-w-xl">
                Real care can't be rushed in 15 minutes. We don't do "drive-by"
                visits — every call is long enough to do things properly.
              </p>
            </div>
          </div>

          <aside className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="bg-[var(--ss-cream)] rounded-3xl p-7 border border-[var(--ss-gold)]/30">
              <div className="font-serif text-2xl text-[var(--ss-teal-800)]">
                Set up visiting care
              </div>
              <p className="mt-2 text-sm text-[var(--ss-ink-soft)]">
                Tell us what's needed and we'll design a visit pattern around it.
              </p>
              <div className="mt-5">
                <EnquiryForm defaultService="visiting" sourcePage="visiting-care" />
              </div>
            </div>
          </aside>
        </div>
      </section>

      <CTABanner />
    </main>
  );
};

export default VisitingCarePage;
